import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { useI18n } from '../hooks/useI18n';
import Button from './ui/Button';

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  if (isAuthenticated) return children;

  return <main className="flex min-h-[55vh] items-center justify-center px-4 py-10"><section className="glass-card w-full max-w-md rounded-3xl p-6 text-center sm:p-8"><LogIn className="mx-auto h-8 w-8 text-brand" aria-hidden="true" /><h1 className="mt-4 text-xl font-bold text-ink">{t('auth_required_title')}</h1><p className="mt-2 text-sm leading-6 text-muted">{t('auth_required_body')}</p><Button className="mt-6" onClick={() => navigate('/login')}>{t('auth_required_action')}</Button></section></main>;
}
